export default __webpack_public_path__ + "static/media/drawers.631135b0.jpg";